export const REMOVE_INACTIVE_TITLE = 'REMOVE ITEM FROM QUOTE'
export const REMOVE_INACTIVE_MESSAGE = 'One or more item(s) is no longer available. Please remove from quote to proceed.'
export const REMOVE_INCOMPATIBLE_MESSAGE = 'One or more item(s) is not compatible with your vehicle. Please remove from quote to proceed.'
export const NO_ITEMS_TITLE = 'NO ITEMS IN QUOTE'
export const NO_ITEMS_MESSAGE = 'There are currently no item(s) in your shopping quote. Click on a link below to shop for tires.'
